
import { ActionTypes as MobileTokenTypes, ActionCreators as MobileTokenCreators } from './mobileToken';

const ActionTypes = {
  MobileTokenTypes,
};

const ActionCreators = {
  MobileTokenCreators,
};

export { ActionTypes, ActionCreators };
